import React, { useMemo } from 'react'
import { motion } from 'motion/react'

import { EffectBackgroundProps } from '../types'

export const WavyEffect = React.memo(({ layerStyle, index, values }: EffectBackgroundProps) => {
  const effectColors = useMemo(() => values.effectColors || ['#6366f1', '#8b5cf6', '#ec4899'], [values.effectColors])
  const effectSpeed = values.effectSpeed ?? 100
  const effectOpacity = values.effectOpacity ?? 100
  const effectBackgroundColor = values.effectBackgroundColor || '#000000'
  const opacityValue = effectOpacity / 100

  return (
    <div
      style={{
        position: 'absolute' as const,
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -index - 1,
        overflow: 'hidden',
        backgroundColor: effectBackgroundColor,
      }}
    >
      <svg
        className='absolute inset-0 w-full h-full'
        viewBox='0 0 100 100'
        preserveAspectRatio='none'
        style={{ opacity: opacityValue }}
      >
        <defs>
          <linearGradient id={`wave-gradient-${index}`} x1='0%' y1='0%' x2='100%' y2='0%'>
            {effectColors.map((color, i) => (
              <stop
                key={i}
                offset={`${(i / Math.max(effectColors.length - 1, 1)) * 100}%`}
                stopColor={color}
                stopOpacity='0.6'
              />
            ))}
          </linearGradient>
        </defs>

        <motion.path
          fill={`url(#wave-gradient-${index})`}
          animate={{
            d: [
              'M0,30 Q25,20 50,30 T100,30 L100,100 L0,100 Z',
              'M0,30 Q25,40 50,30 T100,30 L100,100 L0,100 Z',
              'M0,30 Q25,20 50,30 T100,30 L100,100 L0,100 Z',
            ],
          }}
          transition={{
            duration: 8 * (100 / Math.max(effectSpeed, 1)),
            repeat: Infinity,
            ease: 'easeInOut',
          }}
        />

        <motion.path
          fill={`url(#wave-gradient-${index})`}
          fillOpacity='0.5'
          animate={{
            d: [
              'M0,50 Q25,40 50,50 T100,50 L100,100 L0,100 Z',
              'M0,50 Q25,60 50,50 T100,50 L100,100 L0,100 Z',
              'M0,50 Q25,40 50,50 T100,50 L100,100 L0,100 Z',
            ],
          }}
          transition={{
            duration: 6 * (100 / Math.max(effectSpeed, 1)),
            repeat: Infinity,
            ease: 'easeInOut',
            delay: 0.5,
          }}
        />
      </svg>
    </div>
  )
})
WavyEffect.displayName = 'WavyEffect'
